export default __webpack_public_path__ + "static/media/tech5-black-logo.15fe02d7.svg";